export default __webpack_public_path__ + "static/media/8.12bc2925.jpeg";